<template>
  <div class="vuse-content-wrapper contact-app">
    <vuse-section-definition :title="page" icon="category" />
    <v-container fluid class="">
      <v-row class="mb-3">
        <v-col cols="12" lg="8" md="8">
          <v-row>
            <v-col cols="12" lg="4" md="4">
              <!-- <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                solo
              ></v-text-field> -->
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="4" md="4" class="d-flex justify-end">
         
          <v-btn color="info" @click="addCategory()" class="mr-2">
            Add Folder
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table
        :headers="activeHeaders"
        :items="dataItems"
        class="elevation-1"
        :loading="loading"
        :hide-default-footer="true"
        :options.sync="options"
        :server-items-length="1000"
      >

            <template v-slot:item.actions="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon small class="content-ma-0" v-on="on">
                    <v-icon small>mdi-cogs</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <!-- <v-list-item @click="onDetail(item)">
                    <v-list-item-title>
                      <v-icon small left>person</v-icon>Detail
                    </v-list-item-title>
                  </v-list-item> -->
                  <v-list-item
                    @click="onEdit(item)"
                    v-show="hasAccess('item.edit')"
                  >
                    <v-list-item-title>
                      <v-icon small left>mdi-pencil</v-icon>Edit
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="onDelete(item)"
                    v-show="hasAccess('item.delete')"
                  >
                    <v-list-item-title>
                      <v-icon small left>delete</v-icon>Delete
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

      </v-data-table>
    </v-container>

    <add-form
      :item="selectedItem"
      :show="showEdit"
      @onClosed="clearEdit()"
      @onSucceded="refresh()"
    />

    <delete-dialog
      :item="selectedItem"
      :show="showDelete"
      @onSucceded="refresh()"
      @onClosed="clearDelete()"
    />
    <detail
      :item="selectedItem"
      :show="showDetail"
      @onSucceded="refresh()"
      @onClosed="clearDetail()"
    />
  </div>
</template>
<script>
import AddForm from "./VaultFolder/_Form";
import DeleteDialog from "./VaultFolder/_Delete";
import Detail from "./VaultFolder/_Detail";
import { mapState, mapActions, mapGetters } from "vuex";
import { formatPrice } from "src/utils/helpers";
import { getStorage, setStorage } from "src/utils/helpers";

const SETTING_LIST_KEY = "vaultFolders-columns";
const defaultHeaders = [  
  {
    text: "ID",
    align: "start",
    sortable: false,
    value: "id",
    active: true,
    width: "7%"
  },
  {
    text: "Folder Path",
    align: "start",
    sortable: true,
    value: "pathName",
    active: true,
  },
  {
    text: "Action",
    value: "actions",
    sortable: false,
    readonly: true,
    active: true,
    width: "10%"
  },
];

export default {
  components: {
    AddForm,
    DeleteDialog,
    Detail,
  },
  data() {
    return {
      namespace: "Applications",
      page: "Vault Folders",
      search: "",

      showChangePassword: false,
      showDetail: false,
      showEdit: false,
      showDelete: false,
      showTag: false,
      selectedItem: "",
      panel: [],

      options:{itemsPerPage:-1},

      filter: {
        keyword: "",
      },
      loading: false,

      clients: [],

      headers: defaultHeaders.map((item) => {
        let savedHeaders = getStorage(SETTING_LIST_KEY) || [];
        let nowHeader = savedHeaders.filter(
          (saved) => saved.value === item.value
        );

        if (nowHeader) {
          nowHeader = nowHeader[0];
        }
        return {
          ...item,
          ...nowHeader,
        };
      }),
    };
  },

  async created() {
    await this.refresh();
  },

  watch: {
    headers: {
      handler() {
        setStorage(SETTING_LIST_KEY, this.headers);
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions("vaultFolder", ["getAll"]),
    expandAll() {
      if (this.panel.length > 0) {
        this.panel = [];
      } else {
        this.panel = this.dataItems.map((dataItem) => {
          return dataItem.children.map((c, id) => {
            return id;
          });
        });
      }
    },
    searchClients() {},
    onDelete(item) {
      this.selectedItem = item;
      this.showDelete = true;
    },
    addCategory() {
      this.selectedItem = {};
      this.showEdit = true;
    },
    addTag() {
      this.selectedItem = {};
      this.showTag = true;
    },
    onDeleteTag(item) {
      this.selectedItem = item;
      this.showDelete = true;
    },
    onEditTag(item) {
      if (!this.hasAccess("item.edit")) {
        return false;
      }
      this.selectedItem = item;
      this.showTag = true;
    },

    onEdit(item) {
      if (!this.hasAccess("item.edit")) {
        return false;
      }
      this.selectedItem = item;
      this.showEdit = true;
    },
    onTag(item) {
      if (!this.hasAccess("item.edit")) {
        return false;
      }
      this.selectedItem = item;
      this.showTag = true;
    },
    onDetail(item) {
      this.selectedItem = item;
      this.showDetail = true;
    },
    clearDetail() {
      this.selectedItem = "";
      this.showDetail = false;
    },
    clearEdit() {
      this.selectedItem = "";
      this.showEdit = false;
    },
    clearDelete() {
      this.selectedItem = "";
      this.showDelete = false;
    },
    clearTag() {
      this.selectedItem = "";
      this.showTag = false;
    },
    async refresh() {
      this.loading = true;
      this.getAll();
      this.loading = false;
    },
    formatPrice(value) {
      return formatPrice(value);
    },
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      item: (state) => state.category,
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),

    activeHeaders() {
      return this.headers.filter((header) => header.active);
    },

    categoryItems() {
      return this.$store.getters["vaultFolder/getAll"];
    },

    dataItems() {
      return this.categoryItems;
    },
  },

  beforeDestroy() {
    this.form = null;
    this.contacts = null;
    delete this.form;
    delete this.contacts;
  },
};
</script>